import { createAuthClient } from "@constrigo/auth-client";

export const getBackendUrl = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_BACKEND_URL || "https://api.constrigo.fr";
  }
  return import.meta.env.VITE_BACKEND_URL || "http://localhost:3001";
};

/**
 * Rafraîchissement silencieux de session pour la console Admin.
 *
 * Pas de `cookieScope` : côté serveur, `ADMIN` n'est pas une `CookieAppType`
 * (cf. VALID_COOKIE_APPS dans apps/server/src/utils/cookies.ts), donc les
 * sessions staff n'ont que les cookies génériques `constrigo_token` /
 * `constrigo_csrf` / `constrigo_session`.
 */
export const authClient = createAuthClient({
  trpcUrl: `${getBackendUrl()}/trpc`,
  appHeader: "ADMIN",
});

export function buildAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = { "x-constrigo-app": "ADMIN" };
  const csrf = authClient.readCsrf();
  if (csrf) headers["x-csrf-token"] = csrf;
  return headers;
}
